module.exports = __webpack_public_path__ + "static/media/logo-white.d094039a.png";